import update from '../utilities/update';
import {loading} from './shared/loading';
import {error} from './shared/error';
import {
    CREATE_TRANSACTION_START,
    CREATE_TRANSACTION_SUCCESS,
    CREATE_TRANSACTION_FAIL,
    TOGGLE_TRANSACTION_ADD_MODAL
} from '../actions/transaction/actionTypes';

const initialState={
    loading:false,
    error:null,
    message:null,
    all:[],
    addVisible:false,
}

const createTransaction=(state,action)=>{
    return update(state,{
        loading:false,
        message:'create transaction success',
        all:[...state.all,action.payload]
    })
}

const toggleAddModal=(state,action)=>{
    return update(state,{
        addVisible:!state.addVisible
    })
}

const transactionReducer=(state=initialState,action)=>{
    switch(action.type)
    {
        case CREATE_TRANSACTION_START:
            return loading(state,action);
        case CREATE_TRANSACTION_SUCCESS:
            return createTransaction(state,action);
        case CREATE_TRANSACTION_FAIL:
            return error(state,action);
        case TOGGLE_TRANSACTION_ADD_MODAL:
            return toggleAddModal(state,action);
        default:
            return state;
    }
}

export default transactionReducer;